import React from 'react';

import classes from './TimingWrapper.scss';

const timingWrapper = (props) => (
    <div {...props} className={classes.Wrap}>
        {props.children}
    </div>
);

export default timingWrapper;


// WEBPACK FOOTER //
// ./src/components/Flight/Wrappers/TimingWrapper/TimingWrapper.js